import React, { useState, useEffect, useRef } from 'react';
import { Alert, Box, Typography, Chip, Checkbox, Stack, FormControlLabel, FormGroup, TextField, Button, IconButton, Menu, MenuItem } from '@mui/material';
import { Cancel, MoreVert, FormatListBulleted, Task, Check, AccessibilityNew } from '@mui/icons-material';
import Grid from '@mui/material/Grid';
import SaveButton from '../Components/SaveButton';
import { isEmpty } from 'lodash';
import LinkCode from '../Modals/LinkCode';
import LinkForm from '../Modals/LinkForm';
import LinkAdl from '../Modals/LinkAdl';
import axios from 'axios';
import { APIURL } from '../../../config';

const TaskType = (props) => {
    const [taskTypeList, setTaskTypeList] = useState([]);
    const [selectedTaskTypes, setSelectedTaskTypes] = useState([]);
    const [originalTaskTypes, setOriginalTaskTypes] = useState([]);
    const [newTaskType, setNewTaskType] = useState("");
    const [menuTaskType, setMenuTaskType] = useState({});
    const [tempTaskType, setTempTaskType] = useState({});
    const [taskTypeBeforeEdit, setTaskTypeBeforeEdit] = useState("");
    const [taskTypeEditMode, setTaskTypeEditMode] = useState(false);
    const [openLinkCode, setOpenLinkCode] = useState(false);
    const [openLinkForm, setOpenLinkForm] = useState(false);
    const [openLinkAdl, setOpenLinkAdl] = useState(false);
    const [selectedAdls, setSelectedAdls] = useState(props.initialSelectedAdls || {});
    const [originalAdls, setOriginalAdls] = useState(props.initialSelectedAdls || {});
    const [saving, setSaving] = useState(false);
    const [linksLoading, setLinksLoading] = useState(true);
    const [saveError, setSaveError] = useState('');
    const savingRef = useRef(false);
    const [selectedProcCodes, setSelectedProcCodes] = useState({});
    const [originalProcCodes, setOriginalProcCodes] = useState({});
    const [selectedForms, setSelectedForms] = useState({});
    const [originalForms, setOriginalForms] = useState({});
    const [newId, setNewId] = useState(-1);
    const [newPayerDets, setNewPayerDets] = useState(props.payerList);

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event, taskType) => {
        setAnchorEl(event.currentTarget);
        setMenuTaskType(taskType);
        setTempTaskType(taskType);
        setTaskTypeBeforeEdit(taskType.title);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const textFieldRef = useRef(null);
    const adlLoading = props.adlLinksLoading ?? false;
    const adlError = props.adlLinksError || '';

    useEffect(() => {
        if (props.initialSelectedAdls) {
            setSelectedAdls(props.initialSelectedAdls);
            setOriginalAdls(props.initialSelectedAdls);
        }
    }, [props.initialSelectedAdls]);

    useEffect(() => {
        console.log(taskTypeEditMode)
        if (taskTypeEditMode) {
            textFieldRef.current?.focus();
        }
    }, [taskTypeEditMode]);

    useEffect(() => {
        let cancelled = false;
        async function fetchData() {
            setLinksLoading(true);
            setTaskTypeList(props.taskTypeList.map((type) => {
                return { title: type.EntityValue, id: type.ddID, deletable: type.is_Active === 3 || type.is_Active === 4, is_Active: type.is_Active }
            }));
            setSelectedTaskTypes(props.taskTypeList.filter((type) => type.is_Active === 0 || type.is_Active === 3).map((type) => {
                return { title: type.EntityValue, id: type.ddID, deletable: type.is_Active === 3 || type.is_Active === 4, is_Active: type.is_Active }
            }));
            setOriginalTaskTypes(props.taskTypeList.map((type) => {
                return { title: type.EntityValue, id: type.ddID, deletable: type.is_Active === 3 || type.is_Active === 4, is_Active: type.is_Active }
            }));

            // Fetch every task type's links at once; the section stays disabled until they arrive,
            // because setting them below would overwrite anything linked in the meantime.
            const [newPayerDetails, procResponses, formResponses] = await Promise.all([
                axios.get(APIURL + `/associate_payer`, {
                    params: {
                        compId: props.comp_id,
                    }
                }),
                Promise.all(props.taskTypeList.map((taskType) => axios.get(APIURL + '/procedureCodes', { params: { dropdown_id: taskType.ddID } }))),
                Promise.all(props.taskTypeList.map((taskType) => axios.get(APIURL + '/task_form', { params: { taskType_id: taskType.ddID, company_id: props.comp_id } }))),
            ]);
            if (cancelled) return;

            setNewPayerDets((props.payerList || []).filter((p) => newPayerDetails.data.map((p) => p.payerId).includes(p.payer_id)));

            let selectedProcCodes = {};
            let selectedForms = {};

            props.taskTypeList.forEach((taskType, index) => {
                selectedProcCodes[taskType.ddID] = procResponses[index].data[0]?.procedure_code_id || null;
                selectedForms[taskType.ddID] = formResponses[index].data.map((form) => form.form_id);
            });
            setSelectedProcCodes(selectedProcCodes);
            setOriginalProcCodes(selectedProcCodes);
            setSelectedForms(selectedForms);
            setOriginalForms(selectedForms);

        }

        fetchData().catch(error => {
            if (cancelled) return;
            console.error(error);
            setSaveError('Unable to load task settings completely. Reopen Settings to retry.');
        }).finally(() => {
            if (!cancelled) setLinksLoading(false);
        });

        return () => { cancelled = true; };
    }, [props.taskTypeList]);


    // Link Code saves on its own, so re-read only that task type's code instead of reloading
    // the whole list, which would throw away the user's unsaved changes.
    const refreshProcCode = async (taskTypeId) => {
        try {
            const response = await axios.get(APIURL + '/procedureCodes', { params: { dropdown_id: taskTypeId } });
            const procCodeId = response.data[0]?.procedure_code_id || null;
            setSelectedProcCodes(previous => ({ ...previous, [taskTypeId]: procCodeId }));
            setOriginalProcCodes(previous => ({ ...previous, [taskTypeId]: procCodeId }));
        } catch (error) {
            console.error(error);
        }
    }

    const handleCheckBoxChange = (event) => {
        if (event.target.checked) {
            let taskType = taskTypeList.find((taskType) => taskType.id == event.target.id);
            console.log(taskType.id == event.target.id);
            setSelectedTaskTypes([...selectedTaskTypes, { title: event.target.name, id: taskType.id, deletable: taskType.deletable }]);
            setTaskTypeList(taskTypeList.map((t) => t.id == event.target.id ? { ...t, is_Active: t.is_Active - 1 } : t));
        } else {
            setSelectedTaskTypes(selectedTaskTypes.filter((taskType) => taskType.id != event.target.id));
            setTaskTypeList(taskTypeList.map((t) => t.id == event.target.id ? { ...t, is_Active: t.is_Active + 1 } : t));
        }
    }

    const handleChipDelete = (taskType) => {
        setSelectedTaskTypes(selectedTaskTypes.filter((t) => t.id !== taskType.id));
        setTaskTypeList(taskTypeList.map((t) => t.id === taskType.id ? { ...t, is_Active: t.is_Active + 1 } : t));
    }

    const handleNewTaskTypeChange = (event) => {
        setNewTaskType(event.target.value);
    }

    const handleAddNewTaskType = () => {
        if (isEmpty(newTaskType)) return;
        let taskTypeObj = { title: newTaskType, id: newId, deletable: true, is_Active: 4 };
        setTaskTypeList([...taskTypeList, taskTypeObj]);
        setSelectedTaskTypes([...selectedTaskTypes, taskTypeObj]);
        setNewTaskType("");
        setNewId(newId - 1);
    }

    const handleDeleteTaskType = (taskType) => {
        setTaskTypeList(taskTypeList.filter((t) => t.id !== taskType.id));
        setSelectedTaskTypes(selectedTaskTypes.filter((t) => t.id !== taskType.id));
    }

    const handleSave = async () => {
        if (savingRef.current || linksLoading || adlLoading || adlError) return;
        savingRef.current = true;
        setSaving(true);
        setSaveError('');
        let taskTypesToInsert = taskTypeList.filter((t) => t.id < 0);
        let taskTypesToUpdateName = taskTypeList.filter((t) => {
            let originalTaskType = originalTaskTypes.find((ot) => ot.id === t.id);
            return originalTaskType && originalTaskType.title !== t.title;
        });
        let taskTypesToUpdateStatus = taskTypeList.filter((t) => {
            let originalTaskType = originalTaskTypes.find((ot) => ot.id === t.id);
            if (!originalTaskType) {
                return false;
            }
            if ((originalTaskType.is_Active === 0 || originalTaskType.is_Active === 3) && !selectedTaskTypes.find((st) => st.id === t.id)) {
                return true;
            }
            if ((originalTaskType.is_Active === 1 || originalTaskType.is_Active === 4) && selectedTaskTypes.find((st) => st.id === t.id)) {
                return true;
            }
            return false;
        });
        let taskTypesToDelete = originalTaskTypes.filter((ot) => {
            return !taskTypeList.some((t) => t.id === ot.id);
        });

        // let procCodesToUpdate = Object.keys(selectedProcCodes).filter((key) => selectedProcCodes[key] !== originalProcCodes[key]);
        let formsToUpdate = Object.keys(selectedForms).filter((key) => JSON.stringify(selectedForms[key]) !== JSON.stringify(originalForms[key]));
        let adlsToUpdate = [];
        Object.keys(selectedAdls).forEach((key) => {
            const activityIds = [...new Set([...(selectedAdls[key]?.ADL || []), ...(selectedAdls[key]?.IADL || [])])];
            const originalActivityIds = [...new Set([...(originalAdls[key]?.ADL || []), ...(originalAdls[key]?.IADL || [])])];
            if (taskTypeList.some(type => String(type.id) === key) && JSON.stringify(activityIds.sort()) !== JSON.stringify(originalActivityIds.sort())) {
                adlsToUpdate.push({ taskType_id: key, adl_category: 'ADL', adl_keys: activityIds });
            }
        });

        try {
            const promises = taskTypesToInsert.map((t) => {
                return axios.post(APIURL + "/dropdowns?comp_id=" + props.comp_id + "&is_Active=" + t.is_Active, {
                    entityValue: t.title,
                    entityName: "taskType"
                });
            }).concat(
                taskTypesToUpdateName.map((t) => {
                    return axios.put(APIURL + "/dropdowns", {
                        ddId: t.id,
                        entityValue: t.title
                    });
                }),
                taskTypesToUpdateStatus.map((t) => {
                    return axios.put(APIURL + "/dropdowns", {
                        ddId: t.id,
                        is_Active: t.is_Active
                    });
                }),
                taskTypesToDelete.map((t) => {
                    return axios.put(APIURL + "/dropdowns/company/config", {
                        ddId: t.id
                    });
                }),
                // procCodesToUpdate.map((key) => {
                //     return axios.post(APIURL + "/procedureCodes/handleMappingForTaskProcCode", {
                //         dropdown_id: key,
                //         procedure_code_id: selectedProcCodes[key],
                //         comp_id: props.comp_id
                //     });
                // }),
                formsToUpdate.map((key) => {
                    return axios.post(APIURL + "/task_form", {
                        taskType_id: key,
                        form_ids: selectedForms[key],
                        company_id: props.comp_id,
                        created_by: props.user_id
                    });
                }),
                adlsToUpdate.map((update) => {
                    return axios.post(APIURL + "/adl_tasktype", {
                        taskType_id: update.taskType_id,
                        adl_category: update.adl_category,
                        activity_ids: update.adl_keys.map(Number),
                        company_id: props.comp_id,
                        created_by: props.user_id
                    }).then(response => {
                        if (response.data?.code !== 200) throw new Error(response.data?.message || 'Unable to save activity links');
                        setOriginalAdls(previous => ({
                            ...previous,
                            [update.taskType_id]: { ADL: [...update.adl_keys], IADL: [] },
                        }));
                        return response;
                    });
                })
            );
            const results = await Promise.allSettled(promises);
            const failed = results.find(result => result.status === 'rejected' || (result.value?.data?.code && Number(result.value.data.code) !== 200));
            if (failed) throw failed.reason || new Error(failed.value.data.message || 'Unable to save task settings');
            setOriginalTaskTypes(taskTypeList);
            setOriginalProcCodes(selectedProcCodes);
            setOriginalForms(selectedForms);
            setOriginalAdls(selectedAdls);
            if (taskTypesToInsert.length) await props.getTaskTypeData();
        } catch (error) {
            console.error(error);
            setSaveError(error.response?.data?.message || error.message || 'Unable to save task settings. Please retry.');
        } finally {
            savingRef.current = false;
            setSaving(false);
        }
    }

    useEffect(() => {
        console.log(taskTypeEditMode);
    }, [taskTypeEditMode]);


    return (
        <Box sx={{ flexGrow: 1 }}>
            {linksLoading && <Typography role="status">Loading linked codes and forms…</Typography>}
            {adlLoading && <Typography role="status">Loading ADL/IADL links…</Typography>}
            {adlError && <Alert severity="error" action={<Button onClick={() => props.onAdlLinksRetry && props.onAdlLinksRetry()}>Retry</Button>}>{adlError}</Alert>}
            {saveError && <Alert severity="error">{saveError}</Alert>}
            <Box component="fieldset" disabled={saving || linksLoading} sx={{ border: 0, p: 0, m: 0, minWidth: 0 }}>
            <Grid container spacing={2}>
                <Grid size={props.leftColumnSize}>
                    <Stack spacing={1}>
                        <Typography variant="h5">
                            Task Types
                        </Typography>
                        <Typography variant="body1" sx={{ color: 'gray' }}>
                            What all types of tasks do you perform?
                        </Typography>
                    </Stack>
                </Grid>
                <Grid size={props.rightColumnSize}>
                    <Stack spacing={1}>
                        <Typography variant="h6">
                            Types
                        </Typography>
                        <Box sx={{ minHeight: 32 }}>
                            <Box sx={{ minHeight: 40 }}>
                                {selectedTaskTypes.length === 0 && <Typography variant="body1" sx={{ color: 'gray' }}>No Types selected</Typography>}
                                {selectedTaskTypes.map((taskType, index) => {
                                    return (
                                        <Chip key={index} label={taskType.title} onDelete={() => handleChipDelete(taskType)} sx={{ mr: 1, mb: 1 }} color="primary" />
                                    );
                                })}
                            </Box>
                            <Typography variant="h6">
                                Select Types
                            </Typography>
                        </Box>
                        <FormGroup>
                            <Grid container spacing={0}>
                                {taskTypeList.map((taskType, index) => (
                                    <Grid size={6} key={index}>
                                        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                            {taskTypeEditMode && menuTaskType.id === taskType.id ?
                                                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', margin: 0 }}>
                                                    <Checkbox checked={selectedTaskTypes.find((t) => t.id === taskType.id) ? true : false} onChange={handleCheckBoxChange} name={taskType.title} id={taskType.id} sx={{ margin: 0 }} />
                                                    <Box>
                                                        <TextField
                                                            variant="outlined"
                                                            size='small'
                                                            value={tempTaskType.title}
                                                            inputRef={textFieldRef}
                                                            onBlur={() => {
                                                                if (!taskTypeList.some(taskType => taskType.title === tempTaskType.title)) {
                                                                    setTaskTypeEditMode(false);
                                                                    setTaskTypeList(taskTypeList.map((t) => t.id === taskType.id ? tempTaskType : t));
                                                                    if (selectedTaskTypes.find((t) => t.id === taskType.id)) {
                                                                        setSelectedTaskTypes(selectedTaskTypes.map((t) => t.id === taskType.id ? tempTaskType : t));
                                                                    }
                                                                }
                                                            }}
                                                            onChange={(event) => {
                                                                console.log(tempTaskType);
                                                                setTempTaskType({ ...tempTaskType, title: event.target.value });
                                                            }}
                                                            fullWidth
                                                            inputProps={{ style: { paddingTop: 1, paddingBottom: 1 } }}
                                                        />
                                                        {taskTypeBeforeEdit !== tempTaskType.title && taskTypeList.some(taskType => taskType.title === tempTaskType.title) && <Typography variant="body2" color="error" sx={{ mt: 1 }}>Task Type already exists</Typography>}
                                                    </Box>
                                                </Box> :
                                                <FormControlLabel
                                                    sx={{ height: 25, alignSelf: 'center' }}
                                                    control={<Checkbox checked={selectedTaskTypes.find((t) => t.id === taskType.id) ? true : false} onChange={handleCheckBoxChange} name={taskType.title} sx={{ margin: 0 }} id={taskType.id} />}
                                                    label={taskType.title}
                                                />
                                            }
                                            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', flexWrap: 'nowrap' }}>
                                                {selectedProcCodes[taskType.id] &&
                                                    <IconButton size='small' sx={{ bottom: 6 }} onClick={(event) => { handleClick(event, taskType); handleClose(); setOpenLinkCode(true); }}>
                                                        <Task fontSize='small' />
                                                    </IconButton>
                                                }
                                                {selectedForms[taskType.id]?.length > 0 &&
                                                    <IconButton size='small' sx={{ bottom: 6 }} onClick={(event) => { handleClick(event, taskType); handleClose(); setOpenLinkForm(true); }}>
                                                        <FormatListBulleted fontSize='small' />
                                                    </IconButton>
                                                }
                                                                                    {(selectedAdls[taskType.id]?.ADL?.length > 0 || selectedAdls[taskType.id]?.IADL?.length > 0) &&
                                                    <IconButton aria-label={`Link ADL / IADL for ${taskType.title}`} title="Link ADL / IADL" disabled={saving || adlLoading || !!adlError || taskType.id <= 0} size='small' sx={{ bottom: 6 }} onClick={(event) => { handleClick(event, taskType); handleClose(); setOpenLinkAdl(true); }}>
                                                        <AccessibilityNew fontSize='small' />
                                                    </IconButton>
                                                }
                                                <IconButton size='small' sx={{ bottom: 6 }} onClick={(event) => handleClick(event, taskType)}>
                                                    <MoreVert fontSize='small' />
                                                </IconButton>
                                            </Box>
                                        </Box>
                                    </Grid>
                                ))}
                                <Menu
                                    id="long-menu"
                                    anchorEl={anchorEl}
                                    open={open}
                                    onClose={handleClose}
                                >
                                    {menuTaskType.deletable &&
                                        <MenuItem onClick={() => { setTaskTypeEditMode(true); handleClose(); }}>Edit</MenuItem>
                                    }
                                    {menuTaskType.deletable &&
                                        <MenuItem onClick={() => { handleDeleteTaskType(menuTaskType); handleClose(); }}>Delete</MenuItem>
                                    }
                                    <MenuItem onClick={() => { setOpenLinkCode(true); handleClose(); }}>Link Code</MenuItem>
                                    <MenuItem onClick={() => { setOpenLinkForm(true); handleClose(); }}>Link Form</MenuItem>
                                    <MenuItem disabled={saving || adlLoading || !!adlError || menuTaskType.id <= 0} onClick={() => { setOpenLinkAdl(true); handleClose(); }}>Link ADL / IADL</MenuItem>
                                    {menuTaskType.id <= 0 && <MenuItem disabled>Save this task type before linking ADL/IADL</MenuItem>}
                                </Menu>
                            </Grid>
                        </FormGroup>
                        {!props.disableAddNew &&
                            <Box>
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                    <Box sx={{ width: '100%' }}>
                                        <TextField
                                            variant="outlined"
                                            label={`Add New Types`}
                                            size='small'
                                            value={newTaskType}
                                            onChange={handleNewTaskTypeChange}
                                            fullWidth
                                        />
                                    </Box>
                                    <Button variant="contained" sx={{ ml: 2, width: 100 }} color="primary" onClick={handleAddNewTaskType} disabled={!newTaskType || taskTypeList.some(taskType => taskType.title === newTaskType)}>Add</Button>
                                </Box>
                                {taskTypeList.some(taskType => taskType.title === newTaskType) && <Typography variant="body2" color="error" sx={{ mt: 1 }}>Task Type already exists</Typography>}
                            </Box>
                        }
                        <SaveButton onClick={() => handleSave()} disabled={saving || linksLoading || adlLoading || !!adlError || (JSON.stringify(taskTypeList) === JSON.stringify(originalTaskTypes) && JSON.stringify(selectedProcCodes) === JSON.stringify(originalProcCodes) && JSON.stringify(selectedForms) === JSON.stringify(originalForms) && JSON.stringify(selectedAdls) === JSON.stringify(originalAdls))} />
                    </Stack>
                </Grid>
            </Grid>
            </Box>
            <LinkCode open={openLinkCode} setOpen={setOpenLinkCode} onProcCodeSaved={refreshProcCode} procList={props.procList} providerList={props.providerList} officeList={props.officeList} payerList={newPayerDets} taskType={menuTaskType} originalSelectedProcCode={props.procList.find((procCode) => procCode.procCode_id == selectedProcCodes[menuTaskType.id])} selectedProcCodes={selectedProcCodes} setSelectedProcCodes={setSelectedProcCodes} getProcedureData={props.getProcedureData} procedureData={props.procedureData} comp_id={props.comp_id} />
            <LinkForm open={openLinkForm} setOpen={setOpenLinkForm} formList={props.formList} taskType={menuTaskType} selectedForms={selectedForms} setSelectedForms={setSelectedForms} comp_id={props.comp_id} user_id={props.user_id} />
            <LinkAdl open={openLinkAdl} setOpen={setOpenLinkAdl} taskType={menuTaskType} selectedAdls={selectedAdls} setSelectedAdls={setSelectedAdls} activities={props.adlCatalog} />
        </Box>
    )
}

export default TaskType;
